export default "__VITE_ASSET__DK7EJ9Kg__"